module.exports = __webpack_public_path__ + "img/shells.d7dc5b19.svg";